import { useFeatureFlags } from 'providers/FeatureFlagsProvider';
import { Permissions, userHasPermission } from 'services/Authorization';
import { FeatureFlags } from 'UI/constants/featureFlags';

export const useHiringAuthorityProfileFeatureFlags = () => {
  const { checkIfFeatureFlagEnabled } = useFeatureFlags();

  return {
    canOrganizeTabs: checkIfFeatureFlagEnabled(FeatureFlags.OrganizeTabsHAProfile),
    canUseDailyPlanTask: userHasPermission(Permissions.DailyPlan.CanUseModule),
    isAddDailyPlanTaskEnabled: checkIfFeatureFlagEnabled(FeatureFlags.DailyPlanAddTaskFromProfile),
    isChangeLogsTabEnabled: checkIfFeatureFlagEnabled(FeatureFlags.ChangeLogHA),
    shouldShowKeywords: checkIfFeatureFlagEnabled(FeatureFlags.ContactKeywordTags)
  };
};
